(function () {
  function isHoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 990;
  }

  function initHeaderHoverMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = 'true';

      const details = menu.querySelector('details');
      if (!details) return;
      const summary = details.querySelector(':scope > summary');
      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!isHoverCapable()) return;
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        if (!isHoverCapable()) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderHoverMenus);
  } else {
    initHeaderHoverMenus();
  }
})();
